var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar-section'),_c('Jumbotron-section'),_c('Login-section'),_c('Discover-section'),_c('Touch-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }